import MarcaShow from './MarcaShow'
export {MarcaShow}
export default MarcaShow
